/**
 * updateStats.js
 *
 * Calls a Supabase RPC to atomically update both players' stats
 * when a match finishes. The RPC guards against double-counting
 * via the stats_applied flag on the matches row.
 */

import { supabase } from './supabase';

export const updatePlayerStats = async (match) => {
  if (!match?.id) return;
  if (match.status !== 'finished') return;
  if (match.stats_applied) return;

  const { error } = await supabase.rpc('apply_match_results', {
    p_match_id: match.id,
  });

  if (error) {
    console.error('Failed to apply match results:', error);
  }
};